module.exports = __webpack_public_path__ + "img/slika2.e4848809.png";